import { getEnumValues } from "sprint-common-web";

export enum LanguageSpecificationType {
    Dictionary = 1,
    Sequential = 2
}

export const mapNumberToLanguageSpecificationType = (typeNumber: number): LanguageSpecificationType => {
    if (isNumberLanguageSpecificationType(typeNumber)) {
        return typeNumber;
    }

    throw new Error("Incorrect LanguageSpecificationType");
};

const isNumberLanguageSpecificationType = (typeNumber: number) => {
    const languageType = getEnumValues(LanguageSpecificationType);

    return languageType.some((language: LanguageSpecificationType) => language === typeNumber);
};
